import React from 'react';
import {Modal} from '../../../components';
import {getStatusTextAndStyles} from 'helpers/getStatusTextAndStyles';
import {X} from 'lucide-react';

function ReportedInvoiceModal({show, onClose}) {
  const invoiceDetails = [
    {
      label: 'Business Name',
      value: 'Test Business',
    },
    {
      label: 'Business ID',
      value: '6df03c76-1d83-4a39-a4de-51bd70547aef',
    },
    {
      label: 'IRN',
      value: 'INV002123-94ND90NR-20250611',
    },
    {
      label: 'Issue Date',
      value: '11th June 2025',
    },
    {
      label: 'Due Date',
      value: '18th June 2025',
    },
    {
      label: 'Vat Rate',
      value: '7.5%',
    },
    {
      label: 'Vat Category',
      value: 'Standard',
    },
  ];

  return (
    <Modal
      show={show}
      onClose={onClose}
      extraModalClasses="max-w-[528px] rounded-none absolute bottom-0 sm:relative h-fit max-h-full overflow-y-auto lookup-modal"
      modalPosition="items-start justify-end !p-0"
      fullScreenModal
    >
      <div className="">
        <header className="mt-6 sm:mt-0 px-6 py-3 border-transparent border-[0.5px] border-b-[#E4E4E6] flex items-center justify-between flex-wrap sm:flex-nowrap print:hidden">
          <div className="flex items-center gap-2 flex-col sm:flex-row">
            <h3 className="text-deepBlue text-base font-semibold">
              Invoice Details
            </h3>
          </div>
          <button
            onClick={() => {
              onClose(false);
            }}
            className="bg-[#EDEDED] hidden sm:block rounded-md p-1.5"
          >
            <X size={16} color="#242424" />
          </button>
        </header>

        <div className="mt-3 border-transparent px-6 pb-3 -mx-4 sm:mx-0 rounded">
          {invoiceDetails.map(({label, value}) => (
            <div
              key={label}
              className="py-3.5 flex items-center justify-between"
            >
              <p className="text-small text-deepBlue font-medium capitalize text-left">
                {label}
              </p>

              {label === 'Vat Category' ? (
                <span
                  className={`uppercase py-1 px-2 text-[10px] rounded-full ${
                    getStatusTextAndStyles(value.toLowerCase()).styles
                  }`}
                >
                  {getStatusTextAndStyles(value.toLowerCase()).text || '-'}
                </span>
              ) : (
                <p className="text-sm text-[#5C688E] font-normal w-100 text-right">
                  {value || '-'}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
}

export default ReportedInvoiceModal;
